import React from 'react';
import { Box, Flex } from '@withjoy/joykit';
import { NoSsr } from '@shared/components/NoSsr';
import { StyledHamburger, styles } from './MobileView.styles';
import { MobileViewProvider } from './MobileView.provider';
import { MobileMenuDrawer } from './components/MobileMenuDrawer';
import type { MarcomAppNavBarMobileProps } from '../../AppNavBar.types';
import { ReactComponent as IconBrandLogoMobile } from '@assets/icons/icon-brand-logo-mobile.svg';
import { CatalogSearchDrawerButton, CatalogShopMenuMobile } from '@apps/registry/common/components/Catalog';
import { RegistryGiftBasketWidgetBanner } from '@apps/registry/common/components/RegistryGiftBasketWidget';
import { useShopStorefrontContext } from '@apps/registry/common/components/Catalog/components/ShopStorefrontProvider';

export const MobileView: React.FC<MarcomAppNavBarMobileProps> = props => {
  const { eventId, eventHandle, setMobileNavIsOpen } = props;
  const { config } = useShopStorefrontContext();
  return (
    <MobileViewProvider {...props}>
      <Flex paddingX={5} alignItems="center" position="sticky" top={'0px'} backgroundColor="white" zIndex={10} justifyContent="space-between">
        <Flex alignItems="center">
          <StyledHamburger onClick={() => setMobileNavIsOpen(true)} __css={styles.hamburger} />
          <Box as="a" href={config.homePageUrl}>
            <IconBrandLogoMobile />
          </Box>
        </Flex>
        <Flex alignItems="center">
          <CatalogSearchDrawerButton />
          <CatalogShopMenuMobile />
        </Flex>
      </Flex>
      {eventId && eventHandle && <RegistryGiftBasketWidgetBanner eventHandle={eventHandle} eventId={eventId} />}
      <NoSsr>
        <MobileMenuDrawer />
      </NoSsr>
    </MobileViewProvider>
  );
};

MobileView.displayName = 'MarcomAppNavBarMobile';
